import { Injectable } from '@angular/core';
import { ScrollService } from '@app/core/scroll/scroll.service';
import { ClaimAppointmentInterface } from '@app/my-zone/pages/claims/store/entity/appointment.interface';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as fromAppointments from '../actions/appointments.actions';
import * as fromClaims from '../actions/claims.actions';
import { AppointmentsService } from './appointments.service';

@Injectable()
export class AppointmentEffects {

    Load$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromAppointments.LOAD),
        switchMap((action: fromAppointments.Load) =>
            this.appointmentsService.getAppointments(action.payload.dossier_volgnummer).pipe(
                map((resultaat) => resultaat.data.afspraken),
                map((afspraken: ClaimAppointmentInterface[]) => new fromAppointments.LoadSuccess({
                    afspraken: afspraken,
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                })),
                catchError((errors) => of(new fromAppointments.SetErrors({
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                    errors: errors,
                }))),
            ),
        ),
    ));

    Set$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromAppointments.SET),
        switchMap((action: fromAppointments.Set) =>
            this.appointmentsService.setAppointment(action.payload).pipe(
                tap(() => this.scrollService.scrollToElement('#afspraak')),
                tap(() => this.appointmentsService.showModal(action.payload)),
                switchMap(() => [
                    new fromAppointments.SetSuccess(action.payload),
                    new fromClaims.UpdateAppointmentActions({
                        dossier_volgnummer: action.payload.dossier_volgnummer,
                    }),
                ]),
                catchError((errors) => of(new fromAppointments.SetErrors({
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                    errors: errors,
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions,
        private appointmentsService: AppointmentsService,
        private scrollService: ScrollService,
    ) {
    }
}
